<template>
  <div class="">
    <a-form-model ref="ruleForm" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
      <template v-if="form.spType === 0">
        <a-form-model-item prop="spSpeakerName">
          <span slot="label"><b class="text-red">*</b> 作者</span>
          <a-input v-model="form.spSpeakerName" placeholder="输入作者" ref="spSpeakerName" />
        </a-form-model-item>
        <a-form-model-item prop="spGuest">
          <span slot="label"><b class="text-red">*</b> 向谁提问</span>
          <a-select placeholder="选择嘉宾" allowClear v-model="form.spGuestId" ref="spGuest" @change="onGuestChange">
            <a-select-option v-for="item in guests" :key="item.gid" :value="item.gId">
              {{ item.gName }}<template v-if="item.gPost">（{{ item.gPost }}）</template>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="spDatetime">
          <span slot="label"><b class="text-red">*</b> 提问时间</span>
          <a-date-picker v-model="form.spDatetime" ref="spDatetime" show-time placeholder="选择时间" @change="onDateChange" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
        </a-form-model-item>
        <a-form-model-item prop="qtypes">
          <span slot="label">分类</span>
          <a-select mode="multiple" placeholder="选择分类" allowClear v-model="form.qtypes" ref="spCate">
            <a-select-option v-for="item in speakTypes" :key="item.value" :value="item.label">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="spContent">
          <span slot="label"><b class="text-red">*</b> 内容</span>
          <a-textarea v-model="form.spContent" placeholder="提问内容" :rows="5" ref="spContent" />
        </a-form-model-item>
        <a-form-model-item prop="spId" v-if="form.spId">
          <span slot="label">问题状态</span>
          <span class="text-red" v-if="form.spState === 0">待审核</span>
          <span v-else-if="form.spState === 1">已通过</span>
          <span class="text-grey" v-else-if="form.spState === 2">已封禁</span>
        </a-form-model-item>
      </template>
      <template v-else-if="form.spType === 1 || form.spType === 2">
        <a-form-model-item prop="spSpeakerName">
          <span slot="label"><b class="text-red">*</b> 发言人</span>
          <!-- <a-input v-model="form.spSpeakerName" placeholder="输入作者" ref="spSpeakerName" /> -->
          <a-select placeholder="选择发言人" allowClear v-model="form.spSpeakerId" ref="spSpeakerName" @change="onGuestChange">
            <a-select-option value="0" v-if="userinfo.type === 2">主持人</a-select-option>
            <a-select-option v-for="item in guests" :key="item.gId" :value="item.gId">
              {{ item.gName }}<template v-if="item.gPost">（{{ item.gPost }}）</template>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="spDatetime">
          <span slot="label"><b class="text-red">*</b> 发言时间</span>
          <a-date-picker v-model="form.spDatetime" show-time placeholder="选择时间" @change="onDateChange" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
        </a-form-model-item>
        <a-form-model-item prop="spContent">
          <span slot="label"><b class="text-red">*</b> 发言内容</span>
          <a-textarea v-model="form.spContent" placeholder="发言内容" :rows="10" ref="spContent" />
        </a-form-model-item>
        <a-form-model-item prop="spId" v-if="form.spId">
          <span slot="label">发言状态</span>
          <span class="text-red" v-if="form.spState === 0">待审核</span>
          <span v-else-if="form.spState === 1">已通过</span>
          <span class="text-grey" v-else-if="form.spState === 2">已封禁</span>
          <!-- <a-tag class="tag-tiny" color="#f50" v-if="form.spState === 0">待审核</a-tag>
          <a-tag class="tag-tiny" color="#2E82FF" v-else-if="form.spState === 1">已通过</a-tag>
          <a-tag class="tag-tiny" color="#333" v-else-if="form.spState === 2">已封禁</a-tag> -->
        </a-form-model-item>
      </template>
    </a-form-model>
  </div>
</template>

<script>
import audit from '@/mixins/audit'
import { saveSpeak, updateSpeak, getSpeakTypes } from '@/api/interact'
const form = {
  spSpeakerName: '',
  spSpeakerId: undefined,
  spGuest: '',
  spCate: '',
  spDatetime: '',
  spNumber: 0,
  spContent: '',
  qtypes: [],
}
export default {
  name: 'QuestionForm',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [audit],
  data() {
    return {
      form,
      types: [],
    }
  },
  computed: {
    roadshowCates: (vm) => vm.$store.state.app.roadshowCates,
  },
  watch: {
    data() {
      console.log('QuestionForm', this.data)
      this.form = { ...this.data, qtypes: this.data.qtypes ? this.data.qtypes.split(',') : [] }
    },
  },
  methods: {
    onDateChange(date, dateString) {
      console.log(date, dateString)
    },
    loadTypes() {
      getSpeakTypes().then(({ data }) => {
        console.log('types', data)
        if (data.success) {
          this.types = data.result
        }
      })
    },
    handleSubmit(passed = false) {
      let vm = this
      return new Promise((resolve, reject) => {
        let { spSpeakerId, spSpeakerName, spGuestId, spDatetime, spContent, spId, rsId, qtypes, spState, spType, spNumber } = vm.form
        let params = {
          spSpeakerId,
          spSpeakerName,
          spGuestId,
          spDatetime,
          spContent,
          spId,
          rsId,
          spType,
          spState: passed ? 1 : spState,
          qtypes: qtypes.join(','),
          spNumber,
        }
        if (params.spGuestId) {
          let guest = vm.guests.find((g) => g.gId === params.spGuestId)
          params.spGuest = (guest && guest.gName) || ''
        } else {
          params.spGuest = ''
        }
        this.$message.destroy()
        if (spType === 0) {
          if (params.spSpeakerName.trim() === '') {
            this.$message.warning('请输入作者')
            this.$refs.spSpeakerName.focus()
            reject('请输入作者')
            return
          }
          if (params.spGuest.trim() === '') {
            this.$message.warning('请选择提问对象')
            this.$refs.spGuest.focus()
            reject('请输入发言内容')
            return
          }
          if (!spDatetime) {
            this.$message.warning('请选择提问时间')
            this.$refs.spDatetime.focus()
            reject('请输入发言内容')
            return
          }
          if (spContent.trim() === '') {
            this.$message.warning('请输入内容')
            this.$refs.spContent.focus()
            reject('请输入发言内容')
            return
          }
        } else {
          if (!spSpeakerId) {
            this.$message.warning('请选择发言人')
            this.$refs.spSpeakerName.focus()
            reject('请选择发言人')
            return
          }
          if (!spDatetime) {
            this.$message.warning('请选择发言时间')
            this.$refs.spDatetime.focus()
            reject('请输入发言内容')
            return
          }
          if (spContent.trim() === '') {
            this.$message.warning('请输入发言内容')
            this.$refs.spContent.focus()
            reject('请输入发言内容')
            return
          }
          params.spSpeakerId = spSpeakerId === '0' ? '0' : spSpeakerId
          params.spSpeakerName = spSpeakerId === '0' ? '主持人' : this.guests.find((g) => g.gId === spSpeakerId).gName
          params.spType = spSpeakerId === '0' ? 2 : 1
        }
        if (spId) {
          updateSpeak(params)
            .then(({ data }) => {
              if (data.success) {
                resolve(data)
              } else {
                reject(data.msg)
              }
            })
            .catch(() => {
              reject('保存失败')
            })
        } else {
          saveSpeak(params)
            .then(({ data }) => {
              if (data.success) {
                resolve(data)
              } else {
                reject(data.msg)
              }
            })
            .catch(() => {
              reject('保存失败')
            })
        }
      })
    },
    onGuestChange(value, option) {
      console.log(value, option)
    },
  },
  created() {
    this.form = { form, ...this.data, qtypes: this.data.qtypes ? this.data.qtypes.split(',') : [] }
    this.loadTypes()
  },
}
</script>
